import React from "react";
import MediumScreenLines from "../../components/MediumScreenLines";
import BaseTextButton from "../../components/BaseTextButton";
import "./style.scss";
import { useTranslation } from "react-i18next";
export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="not-found-page centering-page">
      <div className="not-found-page__title">
        <span>{t("page_not_found")}</span>
        <BaseTextButton to="/">{t("to_main")}</BaseTextButton>
      </div>
    </div>
  );
}
